import "./coins-card.scss";
// import Image from "../image/image";

const CoinCard = ({ imgSrc, cardText }) => {
  return (
    <div className="coins-card">
      {/* <Image src={imgSrc} /> */}
      <img className="coin-img" src={imgSrc} />
      <div className="coins-text">{cardText}</div>
    </div>
  );
};

export default CoinCard;
